import PropTypes from 'prop-types';
import React, { useEffect } from "react";

import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
// MetisMenu
// Reactstrap

// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";


import logo from "../../assets/images/ci_logo.png";
import logoSymbol from "../../assets/images/logo-symbol.svg";
//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import {
  changeSidebarType,
  showRightSidebarAction,
  toggleLeftmenu,
} from "../../store/actions";

import { getRoleName } from "../../common/utility";
import OurProducts from 'components/CommonForBoth/TopbarDropdown/ourProducts';

const Header = props => {


  const {data} = useSelector(state => ({
    data: state.Login.data
  }))


  function tToggle() {
    let body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }


  useEffect(() => {
    setTimeout(() => {
      tToggle();
    },0)
    
  },[])
  

  let roleName = "";

  if(data){
    roleName = getRoleName(data.roleId)
  }


  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">

            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to={`/${roleName}/dashboard`} className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to={`/${roleName}/dashboard`} className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSymbol} alt="" height="40" />
                </span>
              </Link>
            </div>


            {data && data.roleId == 2 && <h3 className='depot_name'>Western Depot</h3>}
            {data && data.roleId == 1 && <h3 className='depot_name'>DMS</h3>}
            {data && data.roleId == 4 && <h3 className='depot_name'>Western Region</h3>}
            </div>
          <div className="d-flex">
            {/* <OurProducts /> */}
            <NotificationDropdown />
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
